<template>
  <div>
    <div class="width100">
      <headerBackground v-bind="lectureTitle" />
      <div v-if="progressStatus > 4" class="position-status">
        <div>{{ progressStatus }}%</div>
        <div>
          <span class="to-back cursor"><b-icon @click="goBack" icon="arrow-left-short" title="Назад"></b-icon></span>
          <span class="to-up cursor"><b-icon @click="scrollUp" icon="arrow-up" title="Наверх"></b-icon></span>
          <span :class="timerOk ? 'to-next cursor' : 'to-disabled'"><b-icon @click="openNextLecture"
              icon="arrow-right-short"></b-icon></span>
        </div>
      </div>
      <div class="container">
        <div class="row">

          <div :class="'col-md-10 mx-auto col-lg-' + [zoom ? 12 : 8]">
            <breadСrumbsLight />
            <div class="row">
              <div class="col-lg-6">
                <div class="pb-5 text-start">
                  <h2 @click="goBack" class="post-title go-back">Назад</h2>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="pb-5 text-end">
                  <h2 @click="zoom = !zoom" class="zoom-icon cursor">
                    <b-icon v-if="!zoom" icon="arrows-angle-expand" font-scale="1" variant="dark" class="me-1"></b-icon>
                    <b-icon v-else icon="arrows-angle-contract" font-scale="1" variant="dark" class="me-1"></b-icon>
                  </h2>
                </div>
              </div>
            </div>
            <div id="lecture" :style="'zoom: ' + [zoom ? 1.3 : 1] + ';'" class="text-start" v-html="lectureData.text">
            </div>

            <div v-if="lectureData.file_doc == 1" class="py-4">
              <div class="form-group">
                <label>Отправить домашнюю работу преподавателю в формате .pdf, .ptx, .pptx, .doc, .docx, .xls или .xlsx</label>
                <input class="form-control" type="file" id="file" ref="file" @change="handleFileUpload()">
              </div>
              <div class="form-group pt-3">
                <b-button type="submit" variant="primary" @click="submitFile()">Отправить файл</b-button>
              </div>
            </div>

            <b-button size="lg" variant="success" v-if="timerOk" @click="openNextLecture">Открыть и перейти к следующей
              лекции</b-button>
            <!-- <div v-else>Прочитайте лекцию!</div> -->
          </div>
        </div>
      </div>
    </div>
    <cabinetFooter />
    <div v-if="progressStatus > 4" class="progress-line" :style="'width:' + (timeCounter / timeStop * 100) + 'vw;'"></div>
  </div>
</template>
<script>
import headerBackground from '@/components/headerBackground.vue'
import cabinetFooter from '@/components/cabinetFooter.vue'
import breadСrumbsLight from '@/components/breadСrumbsLight.vue'
// import md5 from 'js-md5'
import { Base64 } from 'js-base64';

export default {
  components: {
    headerBackground,
    cabinetFooter,
    breadСrumbsLight
  },
  data() {
    return {
      lectureTitle: {
        name: '1',
        description: '2'
      },
      lectureData: {},
      zoom: false,
      progressStatus: 0,
      timerOk: false,
      counterInterval: null,
      timeStop: 15,
      timeCounter: 0,
      file: ''
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.initLecture();
      },
      deep: true
    }
  },
  mounted() {
    this.initLecture();
    window.addEventListener('scroll', this.calcPersentProgress);
    // window.addEventListener("resize", this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener('scroll', this.calcPersentProgress);
    this.timerStop();
  },
  methods: {
    initLecture() {
      if (this.$route.params.lectureId) {
        this.timerStop();
        this.timerOk = false;
        this.timeCounter = 0;
        this.lectureData = {};
        this.lectureTitle = {};
        this.axios
          .get(this.$store.getters.URL + '/api/lecture/' + this.$route.params.lectureId)
          .then(response => (this.lectureData = response.data.lectureData,
            this.lectureTitle.name = response.data.lectureData.name,
            this.lectureTitle.description = response.data.lectureData.description,
            this.timeStop = this.wordsCount(response.data.lectureData.text),
            this.timerOk = response.data.timerOk,
            this.$store.commit('reDirect', response.data.redirect)
            // this.windowHeight = document.body.clientHeight
            // this.windowHeight = (document.documentElement.clientHeight - document.body.offsetHeight)
          ));
      }
      this.timerStart();
    },
    b64d(string) {
      return Base64.decode(string);
    },
    goBack() {
      this.$router.push({ path: `/personalcabinet/${this.$store.getters.BREADCRUMBS[this.$store.getters.BREADCRUMBS.length - 1].id}` })
      // this.$router.go(-1);
    },
    calcPersentProgress() {
      this.progressStatus = Math.round(window.top.scrollY / (document.body.offsetHeight - document.documentElement.clientHeight) * 100);
      // this.timerStart();
      // if (this.progressStatus === 100 && !this.timerOk) {
      //   this.wrongMessage();
      // }
      // this.windowHeight = (document.documentElement.clientHeight - document.body.offsetHeight);
      // this.windowHeight = document.documentElement.scrollHeight - document.body.offsetHeight;
      // this.windowHeight = document.body.offsetHeight; //- document.body.offsetHeight;
      // return 
    },
    wrongMessage() {
      if (this.$store.getters.POPUP == false || this.$store.getters.POPUP == null) {
        this.scrollUp();
        this.timerOk = false;
        this.timeCounter = 0;
        this.$store.commit('popUpWiev', 2);
        this.$store.commit('popUpTitleWiev', 'Прочитайте лекцию!');
      }
    },
    timerStart() {
      if (this.counterInterval === null && !this.timerOk) {
        this.counterInterval = setInterval(() => {
          if (this.lectureData.pass === '1') {
            this.timerStop();
          } else {
            if (this.timeCounter <= this.timeStop) {
              this.timeCounter++;
              if ((this.progressStatus < 0 || this.progressStatus >= 100) && !this.timerOk) {
                this.wrongMessage();
              }
            } else {
              this.timerStop();
              this.timerOk = true;
            }
          }
        }, 1000);
      }
    },
    timerStop() {
      clearInterval(this.counterInterval);
      this.counterInterval = null;
    },
    wordsCount(str) {
      return Math.round(str.split(' ').length / 5);
    },
    scrollUp() {
      window.scrollTo(0, 0);
    },
    openNextLecture() {
      this.axios
        .get(this.$store.getters.URL + '/api/opennextlecture/' + this.$route.params.lectureId)
        .then(response =>
        (
          this.$store.commit('reDirect', response.data.redirect)
        )
        );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submitFile() {
      let formData = new FormData();
      formData.append('doc', this.file);
      this.axios.post(this.$store.getters.URL + '/api/homework/' + this.lectureData.id, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response =>
      (
        this.$store.commit('popUpWiev', response.data.popUp),
        this.$store.commit('popUpTitleWiev', response.data.title),
        this.$store.commit('popUpTextWiev', response.data.text)
      )
      );
    }
  }
}
</script>
<style>
#lecture p {
  word-wrap: break-word;
}
.zoom-icon {
  font-weight: 900;
}

.position-status {
  position: fixed;
  right: 10px;
  top: 50%;
}

.cursor {
  cursor: pointer;
}

.to-up:hover::after {
  content: 'Наверх';
  position: fixed;
  right: 18px;
  top: calc(50% + 70px);
  font-size: 15px;
}

.to-back:hover::after {
  content: 'Назад';
  position: fixed;
  right: 22px;
  top: calc(50% + 70px);
  font-size: 15px;
}

.to-next:hover::after {
  content: 'Вперёд';
  position: fixed;
  right: 18px;
  top: calc(50% + 70px);
  font-size: 15px;
}

.to-disabled {
  color: #b0b0b0;
}

.progress-line {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #6a0583;
  height: 5px;
}

.videoFr {
  margin: 20px 0 20px 0;
  --maxsize: 800px;
  --minsize: 300px;
  --aspect-ratio: 1.7;
  /* max-width: 100%; */
  width: 100%;
  height: 60vh;
  /* min-width: var(--minsize);
  min-height: calc(var(--minsize) / var(--aspect-ratio));
  max-width: var(--maxsize);
  max-height: calc(var(--maxsize) / var(--aspect-ratio)); */

}

/* .video-parent {
display: block;
}
.video-children {
display: block;
width: 30px;
height: 30px;
background-color: #6a0583;
z-index: 100;
position: relative;
bottom:  2px;
right: 20px;
} */
/* div[class^='raichu-button-module__control___'] {
  display: none;
} */
</style>
